import styled from "styled-components";

interface StatusBadgeContainerProps {
  color: "warning" | "info" | "success" | "error" | "canceling";
}

const getColorConfig = (color: string, theme: any) => {
  switch (color) {
    case "canceling":
      return {
        background: "#F5F5F5",
        text: "#666666",
      };
    case "info":
      return {
        background: theme.colors.primary12,
        text: theme.colors.primary,
      };
    case "success":
      return {
        background: theme.colors.green12,
        text: theme.colors.green,
      };
    case "error":
      return {
        background: "#FFEBEE",
        text: theme.colors.red,
      };
    default:
      return {
        background: theme.colors.mainBg,
        text: theme.colors.contentTxt,
      };
  }
};

export const StatusBadgeContainer = styled.div<StatusBadgeContainerProps>`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 16px;
  background: ${(props) => getColorConfig(props.color, props.theme).background};
  border-radius: 6px;
  margin: 8px 0;
`;

export const StatusIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  font-size: 12px;
  flex-shrink: 0;
`;

export const StatusText = styled.span<{
  color: "warning" | "info" | "success" | "error" | "canceling";
}>`
  font-size: 1.4rem;
  font-weight: 600;
  color: ${(props) => getColorConfig(props.color, props.theme).text};
  text-align: center;
  line-height: 1.4;
`;
